import { useIconColors } from './use-icon-colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AreaChartIcon = ({
  size = 25
}) => {
  const colors = useIconColors();
  if (!colors) {
    return /*#__PURE__*/_jsx("div", {});
  }
  const {
    orange,
    purple,
    aqua
  } = colors;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("svg", {
      width: size,
      height: size,
      viewBox: "0 0 80 80",
      children: [/*#__PURE__*/_jsx("polygon", {
        fill: orange,
        points: "0,71.6 28.8,24.9 80,0 80,25.8 29.2,41 "
      }), /*#__PURE__*/_jsx("polygon", {
        fill: purple,
        points: "0,76.2 30.2,44.7 80,29.4 80,48 59,49.6 31,56.2 "
      }), /*#__PURE__*/_jsx("polygon", {
        fill: aqua,
        points: "0,80 32,59.8 59.2,53.6 80,51.4 80,80 "
      })]
    })
  });
};
export default AreaChartIcon;